import { FC } from "react";

interface MailProps {
  className?: string;
}

export const Mail: FC<MailProps> = ({ className }) => (
  <a href="mailto:sklep@all-parts.pl" className={className}>
    sklep@all-parts.pl
  </a>
);
